import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPark"><Path d="M12 2C13.7817 2 15.3168 3.03539 16.0459 4.53418C18.2736 4.80367 20 6.69955 20 9C20 9.49359 19.9189 9.96859 19.7715 10.4131C20.5312 11.2178 21 12.3035 21 13.5C21 15.9853 18.9853 18 16.5 18H13V20H15V22H9V20H11V18H7.5C5.01472 18 3 15.9853 3 13.5C3 12.3043 3.46734 11.218 4.22656 10.4131C4.07938 9.96832 4 9.49296 4 9C4 6.70055 5.72482 4.80495 7.95117 4.53418C8.68038 3.03463 10.2183 2 12 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPark;
